import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import ConstructionsForm from '../components/constructions/ConstructionsForm'
import useConstructionStore from '../stores/ConstructionStore'

export default function CreateConstructionPage({ building }) {
  const history = useHistory()
  const location = useLocation()

  const { construction, previousRoute } = location.state || {}

  const create = useConstructionStore((state) => state.createConstructionItem)
  const update = useConstructionStore((state) => state.updateConstructionItem)

  return (
    <ConstructionsForm
      onSubmit={(values, callback) =>
        construction ? update(values, callback) : create(values, callback)
      }
      handleCancel={() => history.push('/obras')}
      construction={construction}
      previousRoute={previousRoute}
    />
  )
}
